import * as React from "react";

function SvgComponent(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={80}
      height={80}
      viewBox="0 0 100 100"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M11.719 58.79H88.28v17.577H11.72V58.79zM11.719 23.633H88.28V41.21H11.72V23.633z"
        fill="#47568C"
      />
      <path
        d="M50 23.633h38.281V41.21H50V23.633zM50 58.79h38.281v17.577H50V58.79z"
        fill="#2C3B73"
      />
      <path
        d="M97.07 0H2.93A2.9 2.9 0 000 2.93v23.633c0 1.64 1.289 2.93 2.93 2.93h94.14c1.641 0 2.93-1.29 2.93-2.93V2.93A2.9 2.9 0 0097.07 0zM97.07 35.352H2.93A2.9 2.9 0 000 38.282v23.437c0 1.64 1.289 2.93 2.93 2.93h94.14c1.641 0 2.93-1.29 2.93-2.93V38.28a2.9 2.9 0 00-2.93-2.93zM97.07 70.508H2.93A2.9 2.9 0 000 73.438V97.07C0 98.71 1.289 100 2.93 100h94.14c1.641 0 2.93-1.29 2.93-2.93V73.438a2.9 2.9 0 00-2.93-2.93z"
        fill="#61729B"
      />
      <path
        d="M100 2.93v23.633c0 1.64-1.289 2.93-2.93 2.93H50V0h47.07A2.9 2.9 0 01100 2.93zM100 38.281V61.72c0 1.64-1.289 2.93-2.93 2.93H50V35.351h47.07a2.9 2.9 0 012.93 2.93zM100 73.438V97.07c0 1.64-1.289 2.93-2.93 2.93H50V70.508h47.07a2.9 2.9 0 012.93 2.93z"
        fill="#47568C"
      />
      <path
        d="M17.578 85.156a2.93 2.93 0 11-5.859 0 2.93 2.93 0 015.86 0zM29.297 85.156a2.93 2.93 0 11-5.86 0 2.93 2.93 0 015.86 0zM41.016 85.156a2.93 2.93 0 11-5.86 0 2.93 2.93 0 015.86 0zM17.578 50a2.93 2.93 0 11-5.859 0 2.93 2.93 0 015.86 0zM29.297 50a2.93 2.93 0 11-5.86 0 2.93 2.93 0 015.86 0zM41.016 50a2.93 2.93 0 11-5.86 0 2.93 2.93 0 015.86 0zM17.578 14.844a2.93 2.93 0 11-5.859 0 2.93 2.93 0 015.86 0zM29.297 14.844a2.93 2.93 0 11-5.859 0 2.93 2.93 0 015.859 0zM41.016 14.844a2.93 2.93 0 11-5.86 0 2.93 2.93 0 015.86 0z"
        fill="#25D9F8"
      />
    </svg>
  );
}

export default SvgComponent;
